/**
 * SaveToast Component
 * Displays temporary toast notification for save/load feedback
 */
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function SaveToast({ show, message }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          className="save-toast"
        >
          ✓ {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
